const fonts = {
  workSansRegular: "font-family:'Work Sans',sans-serif;font-weight: 500;",
  workSansBold: "font-family:'Work Sans',sans-serif;font-weight: 900;",
  openSansRegular: "font-family:'Open Sans',sans-serif;font-weight: 400;",
  openSansMedium: "font-family:'Open Sans',sans-serif;font-weight: 500;",
  openSansBold: "font-family:'Open Sans',sans-serif;font-weight: 700;"
}

export default fonts
